// Scripts used to reposition Yotpo stars and 'See size' Tangiblee trigger
// Since neither app would allow mobile/desktop duplicate renderings to hide/show with CSS

window.addEventListener('DOMContentLoaded', () => {
    let mobileTargetYotpo = document.querySelector('.product-block--header');
    let desktopTargetYotpo = document.querySelector('.product-block--price.hide-mobile');
    // let mobileTargetTangiblee = document.querySelector('.go-addons-title');
    // let desktopTargetTangiblee = document.querySelector('.go-addons-title');

    function moveYotpoWidget() {
        let yotpoWidget = document.querySelector('.yotpo-reviews-star-ratings-widget');

        if (yotpoWidget) {
            let parent = yotpoWidget.parentElement;

            if (window.innerWidth < 768 && mobileTargetYotpo) {
                mobileTargetYotpo.appendChild(parent);
            } else if (window.innerWidth >= 768 && desktopTargetYotpo) {
                desktopTargetYotpo.appendChild(parent);
            }
        }
    }

    // function moveTangibleeCTA() {
    //     let tangibleeCTA = document.querySelector('.tangiblee-cta-mobile'); 
    //     if (tangibleeCTA) {
    //         if (window.innerWidth < 768 && mobileTargetTangiblee) {
                
    //         mobileTargetTangiblee.before(tangibleeCTA);
    //          } 
    //          // Desktop see size trigger is rendering via third party?
    //         //  else if (window.innerWidth >= 768 && desktopTargetTangiblee) { 
    //         //     desktopTargetTangiblee.before(tangibleeCTA);
    //         // }
    //     }
    // }

    // Mutation Observer for Yotpo
    let observerYotpo = new MutationObserver(() => {
        let yotpoWidget = document.querySelector('.yotpo-reviews-star-ratings-widget');
        if (yotpoWidget) {
            moveYotpoWidget();
            observerYotpo.disconnect();
        }
    });

    observerYotpo.observe(document.body, { childList: true, subtree: true });

    // Mutation Observer for Tangiblee CTA
    // let observerTangiblee = new MutationObserver(() => {
    //     let tangibleeCTA = document.querySelector('.tangiblee-cta-mobile');
    //     if (tangibleeCTA) {
    //         moveTangibleeCTA();
    //         observerTangiblee.disconnect();
    //     }
    // });

    // observerTangiblee.observe(document.body, { childList: true, subtree: true });

    // Run on window resize
    window.addEventListener("resize", () => {
        moveYotpoWidget();
        // moveTangibleeCTA();
    });
});
